module.exports = __webpack_public_path__ + "media/images/flags/cd-14f839c8391cd7bbd11cddba435006d2.svg";